"use strict";
// Canonical catalogue of project file usage types, sections, status, and mime
// enumerations. Merged union of previous declarations in:
//   - backend/src/features/file-upload/types.ts           (pre-migration canonical)
//   - backend/src/features/project-management/types/index.ts  (divergent duplicate — folded in)
//   - frontend/src/utils/enums.ts                         (TS enum form — folded in)
// After feature 240, this is the single source of truth for all three consumers.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMimeType = exports.FileStatus = exports.ProjectFileSection = exports.DbProjectFileUsage = exports.ProjectFileUsage = void 0;
exports.ProjectFileUsage = {
    // Administrative documents
    CERFA_DP: 'CERFA_DP',
    CERFA_PC: 'CERFA_PC',
    CERFA_PCM: 'CERFA_PCM',
    // Legacy CERFA identifiers (kept for records created before CERFA_DP/PC/PCM rename)
    CERFA_13703_11: 'CERFA_13703_11',
    CERFA_13406_12: 'CERFA_13406_12',
    CERFA_13411_11: 'CERFA_13411_11',
    OTHER_APPLICANTS_SHEET: 'OTHER_APPLICANTS_SHEET',
    PROJECT_SHEET: 'PROJECT_SHEET',
    // Client power of attorney provided by the salesman at request time
    CLIENT_PROXY: 'CLIENT_PROXY',
    // Urban analysis
    CADASTRAL_MAP: 'CADASTRAL_MAP',
    HISTORICAL_MONUMENT_MAP: 'HISTORICAL_MONUMENT_MAP',
    URBAN_ANALYSIS: 'URBAN_ANALYSIS',
    URBAN_ANALYSIS_MAP: 'URBAN_ANALYSIS_MAP',
    // Photo or PDF shared on a study by the commercial side or the architect's
    // office (#791). Working document: never in the report, never shown to a client.
    URBAN_ANALYSIS_SHARED_DOCUMENT: 'URBAN_ANALYSIS_SHARED_DOCUMENT',
    LOCATION_PLAN: 'LOCATION_PLAN',
    AERIAL_VIEW: 'AERIAL_VIEW',
    AUTHORIZED_COLOR: 'AUTHORIZED_COLOR',
    PLU: 'PLU',
    PPRI: 'PPRI',
    GEOGRAPHIC_RISK_REPORT: 'GEOGRAPHIC_RISK_REPORT',
    // Construction plans
    PC_MATRIX: 'PC_MATRIX',
    DP_MATRIX: 'DP_MATRIX',
    // PCMI documents
    PCMI1: 'PCMI1',
    PCMI2: 'PCMI2',
    PCMI2_1: 'PCMI2_1',
    PCMI3: 'PCMI3',
    PCMI4: 'PCMI4',
    PCMI5_1: 'PCMI5_1',
    PCMI5_2: 'PCMI5_2',
    PCMI5_3: 'PCMI5_3',
    PCMI5_4: 'PCMI5_4',
    PCMI6: 'PCMI6',
    PCMI78: 'PCMI78',
    // DP documents
    DP1: 'DP1',
    DP2: 'DP2',
    DP2_1: 'DP2_1',
    DP3: 'DP3',
    DP4_1: 'DP4_1',
    DP4_2: 'DP4_2',
    DP4_3: 'DP4_3',
    DP4_4: 'DP4_4',
    DP6: 'DP6',
    DP78: 'DP78',
    DP11: 'DP11',
    // Mandatory project drawing views (provided by salesman at request time)
    VIEW_TOP: 'VIEW_TOP',
    VIEW_RIGHT: 'VIEW_RIGHT',
    VIEW_LEFT: 'VIEW_LEFT',
    VIEW_FRONT: 'VIEW_FRONT',
    VIEW_3D_INSERTION: 'VIEW_3D_INSERTION',
    // Plan types
    GROUND_PLAN: 'GROUND_PLAN',
    CURRENT_GROUND_PLAN: 'CURRENT_GROUND_PLAN',
    FUTUR_GROUND_PLAN: 'FUTUR_GROUND_PLAN',
    FIELD_CUT: 'FIELD_CUT',
    CITY_LOCATION_PLAN: 'CITY_LOCATION_PLAN',
    DISTRICT_LOCATION_PLAN: 'DISTRICT_LOCATION_PLAN',
    // Facades (numeric variants)
    CURRENT_FACADE_1: 'CURRENT_FACADE_1',
    CURRENT_FACADE_2: 'CURRENT_FACADE_2',
    CURRENT_FACADE_3: 'CURRENT_FACADE_3',
    CURRENT_FACADE_4: 'CURRENT_FACADE_4',
    CURRENT_FACADE_5: 'CURRENT_FACADE_5',
    CURRENT_FACADE_6: 'CURRENT_FACADE_6',
    CURRENT_FACADE_7: 'CURRENT_FACADE_7',
    CURRENT_FACADE_8: 'CURRENT_FACADE_8',
    FUTUR_FACADE_1: 'FUTUR_FACADE_1',
    FUTUR_FACADE_2: 'FUTUR_FACADE_2',
    FUTUR_FACADE_3: 'FUTUR_FACADE_3',
    FUTUR_FACADE_4: 'FUTUR_FACADE_4',
    FUTUR_FACADE_5: 'FUTUR_FACADE_5',
    FUTUR_FACADE_6: 'FUTUR_FACADE_6',
    FUTUR_FACADE_7: 'FUTUR_FACADE_7',
    FUTUR_FACADE_8: 'FUTUR_FACADE_8',
    // Facades (directional variants — previously only in pm/types duplicate)
    CURRENT_MAIN_FACADE: 'CURRENT_MAIN_FACADE',
    FUTUR_MAIN_FACADE: 'FUTUR_MAIN_FACADE',
    CURRENT_REAR_FACADE: 'CURRENT_REAR_FACADE',
    FUTUR_REAR_FACADE: 'FUTUR_REAR_FACADE',
    CURRENT_GABLE_1: 'CURRENT_GABLE_1',
    FUTUR_GABLE_1: 'FUTUR_GABLE_1',
    CURRENT_GABLE_2: 'CURRENT_GABLE_2',
    FUTUR_GABLE_2: 'FUTUR_GABLE_2',
    // Pictures and perspectives
    PICTURE_1: 'PICTURE_1',
    PICTURE_2: 'PICTURE_2',
    PICTURE_3: 'PICTURE_3',
    PICTURE_4: 'PICTURE_4',
    PICTURE_5: 'PICTURE_5',
    PICTURE_6: 'PICTURE_6',
    PERSPECTIVE: 'PERSPECTIVE',
    CLOSE_PERSPECTIVE: 'CLOSE_PERSPECTIVE',
    EXISTING_PLANS: 'EXISTING_PLANS',
    IMPLANTATION: 'IMPLANTATION',
    HOUSE_PICTURE: 'HOUSE_PICTURE',
    STREET_PICTURE: 'STREET_PICTURE',
    GARDEN_PICTURE: 'GARDEN_PICTURE',
    MATERIALS: 'MATERIALS',
    // Sketches / overviews (previously only in pm/types duplicate)
    SKETCH: 'SKETCH',
    OVERVIEW: 'OVERVIEW',
    // Administrative — deposit
    DEPOSIT_RECEIPT: 'DEPOSIT_RECEIPT',
    // Other / misc
    COMPLEMENTARY_FILE: 'COMPLEMENTARY_FILE',
    SALES_FILE: 'SALES_FILE',
    INTERNALS: 'INTERNALS',
    UNDEFINED: 'UNDEFINED',
};
// Subset of ProjectFileUsage accepted by Hasura's `project_files_uses_enum`.
// The superset above merges legacy/frontend-only values the DB rejects; upload
// validation uses this list so requests fail before a ticket is issued rather
// than later at file-link mutation time.
exports.DbProjectFileUsage = {
    AUTHORIZED_COLOR: exports.ProjectFileUsage.AUTHORIZED_COLOR,
    CADASTRAL_MAP: exports.ProjectFileUsage.CADASTRAL_MAP,
    CERFA_13406_12: exports.ProjectFileUsage.CERFA_13406_12,
    CERFA_13411_11: exports.ProjectFileUsage.CERFA_13411_11,
    CERFA_13703_11: exports.ProjectFileUsage.CERFA_13703_11,
    CERFA_DP: exports.ProjectFileUsage.CERFA_DP,
    CERFA_PC: exports.ProjectFileUsage.CERFA_PC,
    CERFA_PCM: exports.ProjectFileUsage.CERFA_PCM,
    CITY_LOCATION_PLAN: exports.ProjectFileUsage.CITY_LOCATION_PLAN,
    CLIENT_PROXY: exports.ProjectFileUsage.CLIENT_PROXY,
    CLOSE_PERSPECTIVE: exports.ProjectFileUsage.CLOSE_PERSPECTIVE,
    CURRENT_FACADE_1: exports.ProjectFileUsage.CURRENT_FACADE_1,
    CURRENT_FACADE_2: exports.ProjectFileUsage.CURRENT_FACADE_2,
    CURRENT_FACADE_3: exports.ProjectFileUsage.CURRENT_FACADE_3,
    CURRENT_FACADE_4: exports.ProjectFileUsage.CURRENT_FACADE_4,
    CURRENT_FACADE_5: exports.ProjectFileUsage.CURRENT_FACADE_5,
    CURRENT_FACADE_6: exports.ProjectFileUsage.CURRENT_FACADE_6,
    CURRENT_FACADE_7: exports.ProjectFileUsage.CURRENT_FACADE_7,
    CURRENT_FACADE_8: exports.ProjectFileUsage.CURRENT_FACADE_8,
    CURRENT_GROUND_PLAN: exports.ProjectFileUsage.CURRENT_GROUND_PLAN,
    DEPOSIT_RECEIPT: exports.ProjectFileUsage.DEPOSIT_RECEIPT,
    DISTRICT_LOCATION_PLAN: exports.ProjectFileUsage.DISTRICT_LOCATION_PLAN,
    DP1: exports.ProjectFileUsage.DP1,
    DP11: exports.ProjectFileUsage.DP11,
    DP2: exports.ProjectFileUsage.DP2,
    DP2_1: exports.ProjectFileUsage.DP2_1,
    DP3: exports.ProjectFileUsage.DP3,
    DP4_1: exports.ProjectFileUsage.DP4_1,
    DP4_2: exports.ProjectFileUsage.DP4_2,
    DP4_3: exports.ProjectFileUsage.DP4_3,
    DP4_4: exports.ProjectFileUsage.DP4_4,
    DP6: exports.ProjectFileUsage.DP6,
    DP78: exports.ProjectFileUsage.DP78,
    DP_MATRIX: exports.ProjectFileUsage.DP_MATRIX,
    EXISTING_PLANS: exports.ProjectFileUsage.EXISTING_PLANS,
    FIELD_CUT: exports.ProjectFileUsage.FIELD_CUT,
    FUTUR_FACADE_1: exports.ProjectFileUsage.FUTUR_FACADE_1,
    FUTUR_FACADE_2: exports.ProjectFileUsage.FUTUR_FACADE_2,
    FUTUR_FACADE_3: exports.ProjectFileUsage.FUTUR_FACADE_3,
    FUTUR_FACADE_4: exports.ProjectFileUsage.FUTUR_FACADE_4,
    FUTUR_FACADE_5: exports.ProjectFileUsage.FUTUR_FACADE_5,
    FUTUR_FACADE_6: exports.ProjectFileUsage.FUTUR_FACADE_6,
    FUTUR_FACADE_7: exports.ProjectFileUsage.FUTUR_FACADE_7,
    FUTUR_FACADE_8: exports.ProjectFileUsage.FUTUR_FACADE_8,
    FUTUR_GROUND_PLAN: exports.ProjectFileUsage.FUTUR_GROUND_PLAN,
    GARDEN_PICTURE: exports.ProjectFileUsage.GARDEN_PICTURE,
    GEOGRAPHIC_RISK_REPORT: exports.ProjectFileUsage.GEOGRAPHIC_RISK_REPORT,
    GROUND_PLAN: exports.ProjectFileUsage.GROUND_PLAN,
    HISTORICAL_MONUMENT_MAP: exports.ProjectFileUsage.HISTORICAL_MONUMENT_MAP,
    HOUSE_PICTURE: exports.ProjectFileUsage.HOUSE_PICTURE,
    IMPLANTATION: exports.ProjectFileUsage.IMPLANTATION,
    INTERNALS: exports.ProjectFileUsage.INTERNALS,
    MATERIALS: exports.ProjectFileUsage.MATERIALS,
    OTHER_APPLICANTS_SHEET: exports.ProjectFileUsage.OTHER_APPLICANTS_SHEET,
    PC_MATRIX: exports.ProjectFileUsage.PC_MATRIX,
    PCMI1: exports.ProjectFileUsage.PCMI1,
    PCMI2: exports.ProjectFileUsage.PCMI2,
    PCMI2_1: exports.ProjectFileUsage.PCMI2_1,
    PCMI3: exports.ProjectFileUsage.PCMI3,
    PCMI4: exports.ProjectFileUsage.PCMI4,
    PCMI5_1: exports.ProjectFileUsage.PCMI5_1,
    PCMI5_2: exports.ProjectFileUsage.PCMI5_2,
    PCMI5_3: exports.ProjectFileUsage.PCMI5_3,
    PCMI5_4: exports.ProjectFileUsage.PCMI5_4,
    PCMI6: exports.ProjectFileUsage.PCMI6,
    PCMI78: exports.ProjectFileUsage.PCMI78,
    PERSPECTIVE: exports.ProjectFileUsage.PERSPECTIVE,
    PICTURE_1: exports.ProjectFileUsage.PICTURE_1,
    PICTURE_2: exports.ProjectFileUsage.PICTURE_2,
    PICTURE_3: exports.ProjectFileUsage.PICTURE_3,
    PICTURE_4: exports.ProjectFileUsage.PICTURE_4,
    PICTURE_5: exports.ProjectFileUsage.PICTURE_5,
    PICTURE_6: exports.ProjectFileUsage.PICTURE_6,
    PLU: exports.ProjectFileUsage.PLU,
    PPRI: exports.ProjectFileUsage.PPRI,
    PROJECT_SHEET: exports.ProjectFileUsage.PROJECT_SHEET,
    SALES_FILE: exports.ProjectFileUsage.SALES_FILE,
    STREET_PICTURE: exports.ProjectFileUsage.STREET_PICTURE,
    UNDEFINED: exports.ProjectFileUsage.UNDEFINED,
    URBAN_ANALYSIS: exports.ProjectFileUsage.URBAN_ANALYSIS,
    URBAN_ANALYSIS_MAP: exports.ProjectFileUsage.URBAN_ANALYSIS_MAP,
    URBAN_ANALYSIS_SHARED_DOCUMENT: exports.ProjectFileUsage.URBAN_ANALYSIS_SHARED_DOCUMENT,
    VIEW_3D_INSERTION: exports.ProjectFileUsage.VIEW_3D_INSERTION,
    VIEW_FRONT: exports.ProjectFileUsage.VIEW_FRONT,
    VIEW_LEFT: exports.ProjectFileUsage.VIEW_LEFT,
    VIEW_RIGHT: exports.ProjectFileUsage.VIEW_RIGHT,
    VIEW_TOP: exports.ProjectFileUsage.VIEW_TOP,
};
exports.ProjectFileSection = {
    ADMINISTRATIVE: 'ADMINISTRATIVE',
    TOWN_PLANNING: 'TOWN_PLANNING',
    DESIGN: 'DESIGN',
    PICTURES: 'PICTURES',
    OTHER_DOCUMENTS: 'OTHER_DOCUMENTS',
};
exports.FileStatus = {
    PROCESSING: 'PROCESSING',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR',
};
exports.FileMimeType = {
    BMP: 'image/bmp',
    WORD: 'application/msword',
    GIF: 'image/gif',
    WEBP: 'image/webp',
    JPEG: 'image/jpeg',
    TEXT: 'text/plain',
    BPM: 'image/x-portable-bitmap',
    PDF: 'application/pdf',
    PNG: 'image/png',
    POWER_POINT: 'application/vnd.ms-powerpoint',
    SVG: 'image/svg+xml',
    TIFF: 'image/tiff',
    ZIP: 'application/zip',
};
//# sourceMappingURL=usage.js.map